import React from 'react';
import { FacebookIcon, TwitterIcon, LinkedinIcon, InstagramIcon, MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-50 border-t border-gray-100" data-id="element-48">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-12 md:py-16" data-id="element-49">
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-8 md:mb-12" data-id="element-50">
          <div className="col-span-2 md:col-span-1" data-id="element-51">
            <h3 className="text-xl md:text-2xl font-bold text-black mb-3 md:mb-4" data-id="element-52">
              WellAd<span className="text-indigo-600" data-id="element-53">.</span>
            </h3>
            <p className="text-sm md:text-base text-gray-600 mb-4 md:mb-6" data-id="element-54">
              The AI receptionist that answers your calls, schedules
              appointments, and captures leads 24/7.
            </p>
            <div className="flex space-x-2 md:space-x-3" data-id="element-55">
              <a href="https://www.facebook.com/share/19YFWtHXfN/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="w-9 h-9 md:w-10 md:h-10 bg-white rounded-full flex items-center justify-center text-gray-600 hover:text-indigo-600 hover:shadow-md transition-all" data-id="element-56">
                <FacebookIcon size={16} className="md:w-[18px] md:h-[18px]" data-id="element-57" />
              </a>

              <a href="https://www.linkedin.com/company/wellad/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 md:w-10 md:h-10 bg-white rounded-full flex items-center justify-center text-gray-600 hover:text-indigo-600 hover:shadow-md transition-all" data-id="element-58">
                <LinkedinIcon size={16} className="md:w-[18px] md:h-[18px]" data-id="element-59" />
              </a>
              <a href="https://www.instagram.com/wellad_online?igsh=MTdwemtqd2FjNWZnZg%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="w-9 h-9 md:w-10 md:h-10 bg-white rounded-full flex items-center justify-center text-gray-600 hover:text-indigo-600 hover:shadow-md transition-all" data-id="element-60">
                <InstagramIcon size={16} className="md:w-[18px] md:h-[18px]" data-id="element-61" />
              </a>
            </div>
          </div>
          <div data-id="element-62">
            <h4 className="font-bold text-black mb-3 md:mb-4 text-sm md:text-base" data-id="element-63">
              Quick Links
            </h4>
            <ul className="space-y-2 md:space-y-3" data-id="element-64">
              <li data-id="element-65">
                <a href="#" className="text-sm md:text-base text-gray-600 hover:text-black transition-colors" data-id="element-66">
                  Home
                </a>
              </li>
              <li data-id="element-67">
                <a href="#features" className="text-sm md:text-base text-gray-600 hover:text-black transition-colors" data-id="element-68">
                  Features
                </a>
              </li>
              <li data-id="element-69">
                <a href="#how-it-works" className="text-sm md:text-base text-gray-600 hover:text-black transition-colors" data-id="element-70">
                  How It Works
                </a>
              </li>
              <li data-id="element-71">
                <a href="#pricing" className="text-sm md:text-base text-gray-600 hover:text-black transition-colors" data-id="element-72">
                  Pricing
                </a>
              </li>
              <li data-id="element-73">
                <a href="#testimonials" className="text-sm md:text-base text-gray-600 hover:text-black transition-colors" data-id="element-74">
                  Testimonials
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-75">
            <h4 className="font-bold text-black mb-3 md:mb-4 text-sm md:text-base" data-id="element-76">
              Contact Us
            </h4>
            <ul className="space-y-2 md:space-y-3" data-id="element-77">
              <li className="flex items-start text-gray-600 text-sm md:text-base" data-id="element-78">
                <MapPinIcon size={16} className="mr-2 mt-1 flex-shrink-0 md:w-[18px] md:h-[18px]" data-id="element-79" />
                <span data-id="element-80">Brisbane, Australia</span>
              </li>
              <li className="flex items-center text-gray-600 text-sm md:text-base" data-id="element-81">
                <PhoneIcon size={16} className="mr-2 flex-shrink-0 md:w-[18px] md:h-[18px]" data-id="element-82" />
                <span data-id="element-83">07 4428 7360</span>
              </li>
              <li className="flex items-center text-gray-600 text-sm md:text-base" data-id="element-84">
                <MailIcon size={16} className="mr-2 flex-shrink-0 md:w-[18px] md:h-[18px]" data-id="element-85" />
                <span data-id="element-86">hello@wellad.com.au</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="pt-6 md:pt-8 border-t border-gray-200 text-center" data-id="element-87">
          <p className="text-gray-600 text-xs md:text-sm" data-id="element-88">
            © 2023 WellAd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}